<template>
<div>
    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        ref="search_box"
        autofocus
    >
    </v-text-field>

    <v-card
        v-for="(item, index) in search_templates"
        :key="'template_card_'+index"
        style="margin-bottom: 15px"
    >
        <v-card-text
            class="card-text"
            v-on:click="$emit('create-message',item)"
        >
            <div
                class="title"
            >
                {{item.label}}
            </div>
            <div
                v-html="$rc.wrapHTML(item.message_patterns[0])"
            >
            </div>
        </v-card-text>

        <v-card-actions>
            <v-spacer/>
            <v-btn
                color="primary"
                text
                v-on:click="$emit('create-message',item)"
            >
                {{action_label}}
            </v-btn>
        </v-card-actions>

    </v-card>
</div>
</template>

<script>
const _ = require('lodash');
export default {

    props: {
        template_type: {
            type: Object,
            default: function() { return null; }
        },

        action_label: {
            type: String,
            default: function() { return 'Create Bulk Message Using This Template'; },
        },
    },

    data() {
        return {
            full_text: null,
        }
    },

    computed: {
        search_templates() {
            let ret = _.cloneDeep(this.template_type.templates);
            let search_text = (this.full_text ?? '').trim();
            
            if ( search_text == '' ) 
                return ret;

            ret = ret.filter(
                (item) => JSON.stringify(item).toLowerCase().includes(search_text.toLowerCase())
            );
            
            return ret;
        }
    },
}
</script>

<style lang="scss" scoped>
.title
{
    font-size: 18px;
    margin-bottom: 10px;
    color: black;
}

.card-text
{
    cursor: pointer;
}


</style>